import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import ReactMarkdown from 'react-markdown';
import './ProjectsPage.css';

import metroThumbnail from '../assets/images/MetroLandingPage__dc_metro_map.png';
import scraperThumbnail from '../assets/images/WebScraperPage__streamlit_UI.png';
import economicThumbnail from '../assets/images/ProjectPage__economicThumb.jpg';
import botThumbnail from '../assets/images/InsightBotPage__botThumb.jpg';
import topicBotThumbnail from '../assets/images/TopicBotPage__botThumb.png';
import geoThumbnail from '../assets/images/GeospatialPage__thumb.jpg';

const PROJECTS = [
  {
    key: 'economic',
    name: 'Economic Data Analysis',
    thumb: economicThumbnail,
    blurb: 'content/ProjectPage__blurbs/EconomicPage__blurb.md'
  },
  {
    key: 'metro',
    name: 'DC Metro Explorer',
    thumb: metroThumbnail,
    blurb: 'content/ProjectPage__blurbs/MetroLandingPage__blurb.md'
  },
  {
    key: 'webscraper',
    name: 'Web Scraper',
    thumb: scraperThumbnail,
    blurb: 'content/ProjectPage__blurbs/WebScraperPage__blurb.md'
  },
  {
    key: 'insightbot',
    name: 'InsightBot',
    thumb: botThumbnail,
    blurb: 'content/ProjectPage__blurbs/InsightBotPage__blurb.md'
  },
  {
    key: 'topicbot',
    name: 'TopicBot',
    thumb: topicBotThumbnail,
    blurb: 'content/ProjectPage__blurbs/TopicBotPage__blurb.md'
  },
  {
    key: 'geospatial',
    name: 'Geospatial Analysis',
    thumb: geoThumbnail,
    blurb: 'content/ProjectPage__blurbs/GeospatialPage__blurb.md'
  }
];

export default function ProjectsPage({ onNavigate, onBack }) {
  const [blurbs, setBlurbs] = useState({});
  useEffect(() => {
      PROJECTS.forEach(project => {
        fetch(process.env.PUBLIC_URL + project.blurb)
          .then(res => res.text())
          .then(text => {
            setBlurbs(prev => ({ ...prev, [project.key]: text }));
          })
          .catch(console.error);
      });
    }, []);
  
  return (
    <>
      <Helmet>
        <title>Projects | Insight Data LLC</title>
      </Helmet>
      <main className="pr-modern-home">
        <section className="pr-modern-header">
          <button className="back-link pr-modern-back" onClick={onBack}>
            Back to Home
          </button>
        </section>
        <section className="pr-modern-title-section">
          <h1 className="pr-modern-title">Projects</h1>
        </section>
        <section className="pr-modern-cards">
          {PROJECTS.map(p => (
            <div
              key={p.key}
              className="pr-modern-card"
              onClick={() => onNavigate(p.key)}
              tabIndex={0}
              role="button"
              style={{ cursor: 'pointer' }}
            >
              <img src={p.thumb} alt={p.name} className="pr-modern-thumb" />
              <h2>{p.name}</h2>
              <div className="pr-modern-blurb">
                <ReactMarkdown>
                  {blurbs[p.key] || '_Loading..._'}
                </ReactMarkdown>
              </div>
            </div>
          ))}
        </section>
      </main>
    </>
  );
}
